import { IMAGE_BASE_URL } from '../../constants/values';
import { NonEmPlaceOrderStrings } from './PlaceOrderStrings';
var strings = NonEmPlaceOrderStrings.faqs;
export var Faqs = [
    {
        id: 'group-order',
        question: strings.faq1.question(),
        steps: [
            {
                text: strings.faq1.step1(),
            },
            {
                text: strings.faq1.step2(),
            },
            {
                text: strings.faq1.step3(),
                img: {
                    src: IMAGE_BASE_URL + "/s/managed/consumer/teams/group-order-highlight.png",
                    height: 56,
                },
            },
            {
                text: strings.faq1.step4(),
            },
            {
                text: strings.faq1.step5(),
            },
        ],
    },
    {
        id: 'catering',
        question: strings.faq2.question(),
        steps: [
            {
                text: strings.faq2.step1(),
            },
            {
                text: strings.faq2.step2(),
                img: {
                    src: IMAGE_BASE_URL + "/s/managed/consumer/teams/catering-on-carousel.png",
                    height: 128,
                },
            },
            {
                text: strings.faq2.step3(),
            },
        ],
    },
];
